
import { EMPTY_MASTER_FSP_ENTITY, MasterFSPEntity } from "domain/entity/MasterFSP/MasterFSPEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface MasterFSPDropdownOptions {
    shippingLineCompanyDropdownOptions: DropdownProps[],
    consortiumCodeDropdownOptions: DropdownProps[],
    serviceCodeDropdownOptions: DropdownProps[],
    calendarAdjDropdownOptions: DropdownProps[],
    customerTypeDropdownOptions: DropdownProps[],
    splitDaysToDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
    shipmentTypeDropdownOptions: DropdownProps[],
    cargeCodeDropdownOption: DropdownProps[],
    directionDropdownOptions: { [key: string]: DropdownProps[] },
    forwarderCodeDropdownOptions: DropdownProps[],
    agentInfosDropdownOptions: DropdownProps[],
    cntrMovementDropdownOptions: DropdownProps[],
    cntrStatusDropdownOptions: DropdownProps[],
    fspCountingFromDropdownOptions: DropdownProps[],
    fspCountingToDropdownOptions: DropdownProps[],
    fspUomDropdownOptions: DropdownProps[],
    fspCalculateMethodDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
    editingEntity: MasterFSPEntity,
}

export interface MasterFSPMaintenanceModel {
    isLoading: boolean,
    tableData: MasterFSPEntity[],
    currentSelectedRow: MasterFSPEntity,
    selectedRows: MasterFSPEntity[],
    dynamicOptions: MasterFSPDropdownOptions,
    masterState: MasterChangeState,
    isBackMaster: boolean,
    isShowEditPanel: boolean,
    isShowDeleteModal: boolean,
    isRejected: boolean,
    isRejectedCount: number,
    isPendingApproval: boolean,
    isPendingApprovalCount: number,
    searchStatus: string,
    allData: MasterFSPEntity[],
    isShowRejectPad: boolean,
    rejectReason: string,
    isRejecting: boolean,
    isShowCriteriaPanel: boolean,
    searchCriteria: MasterFSPEntity,
    isAllowAutoSearch: boolean,
    isSearch: boolean,
    forceRefresh: boolean,
}

export const EMPTY_MASTER_MASTER_FSPANY_MODEL: MasterFSPMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_MASTER_FSP_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        shippingLineCompanyDropdownOptions: [],
        consortiumCodeDropdownOptions: [],
        serviceCodeDropdownOptions: [],
        calendarAdjDropdownOptions: [],
        customerTypeDropdownOptions: [],
        splitDaysToDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {},
        shipmentTypeDropdownOptions: [],
        cargeCodeDropdownOption: [],
        directionDropdownOptions: {},
        forwarderCodeDropdownOptions: [],
        agentInfosDropdownOptions: [],
        cntrMovementDropdownOptions: [],
        cntrStatusDropdownOptions: [],
        fspCountingFromDropdownOptions: [],
        fspCountingToDropdownOptions: [],
        fspUomDropdownOptions: [],
        fspCalculateMethodDropdownOptions: [],
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_MASTER_FSP_ENTITY,
    },
    isBackMaster: false,
    isShowEditPanel: false,
    isShowDeleteModal: false,
    isRejected: false,
    isRejectedCount: 0,
    isPendingApproval: false,
    isPendingApprovalCount: 0,
    searchStatus: '',
    allData: [],
    isShowRejectPad: false,
    rejectReason: '',
    isRejecting: false,
    isShowCriteriaPanel: false,
    searchCriteria: EMPTY_MASTER_FSP_ENTITY,
    isAllowAutoSearch: true,
    isSearch: false,
    forceRefresh: false
}